import { createResource } from '@atlassian/react-resource-router';
import type { CustomFieldReportsData } from './types.tsx';

const RESOURCE_TYPE_FIELDS_PROJECTS_LIMITS = 'FIELDS_PROJECTS_LIMITS';

export const fieldsProjectsLimitsResource = createResource<CustomFieldReportsData>({
	type: RESOURCE_TYPE_FIELDS_PROJECTS_LIMITS,
	getKey: () => 'fieldsProjectsLimits',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-fields-projects-limits", jiraSpaEntry: "async-resource-fields-projects-limits" */ './get-data/index.tsx'
		),
});
